import React from "react";
import Breadcrumb from "../../common/Breadcrumb";
import BlogGridWrap from "./BlogGridWrap";

function BlogGridPage() {
  return (
    <>
      <Breadcrumb name="Blog Grid" />
      <BlogGridWrap />
    </>
  );
}

export default BlogGridPage;
